import { searchActivities } from "./Activity/search";
import { searchEquipments } from '../perso/Equipment/search';


export function search(state, query) {
  return {
    activities: searchActivities(state.activities, query),
    equipments: searchEquipments(state.equipments, query),
  };
}
